export const AUTHORIZED_ROUTES_LOCAL_STORAGE = '_ark23r_3zLr';
export const TOKEN_COOKIE_STORAGE = '_tw32o_k5Yg';
export const IS_LOGGED_IN_LOCAL_STORAGE = '_im467_Q62n';
export const AUTH_LOCAL_STORAGE = '_auh43m!8Vb';
export const PERMISSION_LOCAL_STORAGE = '_prldg%46Vb';
export const RESOURCE_LOCAL_STORAGE = '_rsq09m@8Vb';
export const COOKIE_EXPIRATION_DAYS = 7;
